import { render, staticRenderFns } from "./check-box-submitted-preview.vue?vue&type=template&id=42170aba&scoped=true&"
import script from "./check-box-submitted-preview.vue?vue&type=script&lang=js&"
export * from "./check-box-submitted-preview.vue?vue&type=script&lang=js&"
import style0 from "./check-box-submitted-preview.vue?vue&type=style&index=0&id=42170aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42170aba",
  null
  
)

component.options.__file = "check-box-submitted-preview.vue"
export default component.exports